import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { trackEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

export function useEventTracker({ variant, listingCurrency, parentComponentName, currency, quantity }: {
  variant: string,
  listingCurrency: string,
  parentComponentName: string,
  currency: string,
  quantity: number,
}) {
  const user = useUser();
  const paypalExpValue = variant === 'buy-now' ? experiments.PAYPAL_BUY_NOW_DESKTOP : experiments.PAYPAL_CHECKOUT_BUTTON;
  const tracked = [paypalExpValue];
  if (user.currency !== listingCurrency) {
    tracked.push(experiments.DC_PAYPAL_ALL_THE_PRESENTMENT_CURRENCIES);
  }
  const customTrackedValues = {
    parentComponentName: parentComponentName,
    buyerCurrency: user.currency,
    listingCurrency: listingCurrency,
    currency: currency,
    quantity: quantity,
  };
  function trackPaypalEvent(eventName: MParticleEventName) {
    trackEvent({
      eventName: eventName,
      experiments: formatExperimentsForEventAttributes(user, tracked),
      ...customTrackedValues,
    });
  }

  return trackPaypalEvent;
}
